import { FocusEvent, useState } from 'react';

import { format } from 'date-fns';
import { isValidDate } from '@aldebaran/common/util/date';
import { parseInlineMarkdown } from '@/util/parseInlineMarkdown';
import { Input } from '@/components/ui/input';

export interface ResponseDateTimeFieldProps {
  value?: number;
  label: string;
  onChange: (value: number | null) => void;
  multiline?: boolean;
  disabled?: boolean;
}

export const ResponseDateTimeField = ({
  value,
  label,
  onChange,
  disabled,
}: ResponseDateTimeFieldProps) => {
  const [inputValue, setInputValue] = useState(
    isValidDate(value) ? format(value, "yyyy-MM-dd'T'HH:mm") : '',
  );

  return (
    <div className="flex w-full flex-col gap-1.5">
      <label className="text-sm font-medium text-indigo-900">
        {parseInlineMarkdown(label)}
      </label>
      <Input
        type="datetime-local"
        disabled={disabled}
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onBlur={(e: FocusEvent<HTMLInputElement>) => {
          const date = new Date(e.target.value);
          if (isValidDate(date)) {
            onChange(date.getTime());
          } else {
            onChange(null);
          }
        }}
        autoComplete="off"
      />
    </div>
  );
};
